import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DesmosGraph } from "./DesmosGraph";
import MathText from "./MathText";
import { motion } from "framer-motion";

interface QuestionCardProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  imageUrl?: string;
  graphExpression?: string;
}

export default function QuestionCard({
  questionNumber,
  totalQuestions,
  question,
  imageUrl,
  graphExpression
}: QuestionCardProps) {
  return (
    <motion.div
      key={questionNumber}
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <Card className="p-8">
        <div className="space-y-6">
        <div className="flex items-center justify-between">
          <Badge variant="default" data-testid="badge-question-number">
            Question {questionNumber} of {totalQuestions}
          </Badge>
        </div>
        <div className="text-xl sm:text-2xl font-semibold leading-relaxed" data-testid="text-question">
          <MathText block>{question}</MathText>
        </div>
        
        {/* Image Display */}
        {imageUrl && (
          <div className="flex justify-center">
            <img 
              src={imageUrl} 
              alt="Question illustration" 
              className="max-w-full h-auto rounded border"
              style={{ maxHeight: '400px' }}
            />
          </div>
        )}

        {/* Desmos Graph Display */}
        {graphExpression && (
          <div className="flex justify-center">
            <DesmosGraph 
              expression={graphExpression} 
              width={500}
              height={350}
            />
          </div>
        )}
      </div>
    </Card>
    </motion.div>
  );
}
